module.exports = __webpack_public_path__ + "static/media/faq.151a583d.svg";